import { NavLink } from "react-router"

function OverviewIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden>
      <path d="M8.557 2.75H4.682A1.932 1.932 0 0 0 2.75 4.682v3.875a1.942 1.942 0 0 0 1.932 1.943h3.875a1.942 1.942 0 0 0 1.943-1.943V4.682A1.942 1.942 0 0 0 8.557 2.75ZM19.318 2.75h-3.875a1.942 1.942 0 0 0-1.943 1.932v3.875a1.943 1.943 0 0 0 1.943 1.943h3.875a1.932 1.932 0 0 0 1.932-1.943V4.682a1.932 1.932 0 0 0-1.932-1.932ZM8.557 13.5H4.682a1.943 1.943 0 0 0-1.932 1.943v3.875a1.932 1.932 0 0 0 1.932 1.932h3.875a1.942 1.942 0 0 0 1.943-1.932v-3.875a1.942 1.942 0 0 0-1.943-1.943ZM19.318 13.5h-3.875a1.943 1.943 0 0 0-1.943 1.943v3.875a1.932 1.932 0 0 0 1.943 1.932h3.875a1.932 1.932 0 0 0 1.932-1.932v-3.875a1.932 1.932 0 0 0-1.932-1.943Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

function ChildrenIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden>
      <circle cx="12" cy="7" r="4" />
      <path d="M5.5 21a6.5 6.5 0 0 1 13 0" strokeLinecap="round" />
    </svg>
  )
}

function GivingIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden>
      <path d="M12 6v12m-3-2.818.879.659c1.171.879 3.07.879 4.242 0 1.172-.879 1.172-2.303 0-3.182C13.536 12.219 12.768 12 12 12c-.725 0-1.45-.22-2.003-.659-1.106-.879-1.106-2.303 0-3.182s2.9-.879 4.006 0l.997.659" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="10" />
    </svg>
  )
}

function SettingsIcon({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className={className} aria-hidden>
      <path d="M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.727 14.727a1.5 1.5 0 0 0 .3 1.655l.055.054a1.816 1.816 0 0 1 0 2.573 1.818 1.818 0 0 1-2.573 0l-.055-.055a1.5 1.5 0 0 0-1.654-.3 1.5 1.5 0 0 0-.91 1.373v.155a1.818 1.818 0 1 1-3.636 0V20.1a1.5 1.5 0 0 0-.981-1.373 1.5 1.5 0 0 0-1.655.3l-.054.055a1.818 1.818 0 0 1-3.106-1.287 1.818 1.818 0 0 1 .533-1.286l.054-.055a1.5 1.5 0 0 0 .3-1.654 1.5 1.5 0 0 0-1.372-.91h-.155a1.818 1.818 0 1 1 0-3.636H3.9a1.5 1.5 0 0 0 1.373-.981 1.5 1.5 0 0 0-.3-1.655l-.055-.054a1.818 1.818 0 1 1 2.573-2.573l.055.054a1.5 1.5 0 0 0 1.654.3H9.3a1.5 1.5 0 0 0 .909-1.372v-.155a1.818 1.818 0 1 1 3.636 0V3.9a1.5 1.5 0 0 0 .91 1.373 1.5 1.5 0 0 0 1.654-.3l.054-.055a1.818 1.818 0 0 1 2.573 2.573l-.054.054a1.5 1.5 0 0 0-.3 1.655V9.3a1.5 1.5 0 0 0 1.372.91h.155a1.818 1.818 0 0 1 0 3.636H20.1a1.5 1.5 0 0 0-1.373.909v.072Z" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export const NAV_ITEMS = [
  { to: "/donor", end: true, label: "Overview", icon: OverviewIcon },
  { to: "/donor/children", end: false, label: "My Children", icon: ChildrenIcon },
  { to: "/donor/giving", end: false, label: "Giving history", icon: GivingIcon },
  { to: "/donor/settings", end: false, label: "Settings", icon: SettingsIcon },
] as const

export function DonorSidebar() {
  return (
    <aside className="hidden lg:flex w-[280px] flex-none flex-col border-r border-gold-500 bg-white p-6">
      <nav className="flex flex-col gap-1">
        {NAV_ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-lg px-4 py-3 text-base font-medium transition-all duration-200 ${
                isActive
                  ? "bg-forest-950 text-white shadow-sm"
                  : "text-ink/70 hover:bg-cream-100 hover:text-ink"
              }`
            }
          >
            <item.icon className="h-5 w-5 flex-none" />
            <span>{item.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  )
}
